import axios from 'axios';
import {sleep} from 'api/util';
import {cloneDeep, unionBy} from 'lodash';

const ADD_IMAGE = 'coverPageImages/actions/ADD_IMAGE';
const REMOVE_IMAGE = 'coverPageImages/actions/REMOVE_IMAGE';
const SELECT = 'coverPageImages/actions/SELECT';
const FRANCHISE = 'coverPageImages/actions/FRANCHISE';

export const initialState = {
  custom: [],
  large: [],
  colours: [],
  selections: {},
};

const CoverPageImagesDuck = (state = initialState, action) => {
  const itemCriterion = (item) => {
    return JSON.stringify({
      imageUri: !!item ? item.imageUri : null,
      type: !!item ? item.type : null,
    });
  };
  const partialMatches = (item) => {
    return item.imageUri === action.payload.custom.imageUri
      && item.type === action.payload.custom.type;
  };

  let custom;

  switch (action.type) {
    case ADD_IMAGE:
      custom = unionBy([action.payload], state.custom, itemCriterion);
      return {
        ...state,
        custom: custom,
      };
    case REMOVE_IMAGE:
      custom = state.custom.filter(item => {
        return !partialMatches(item);
      });

      let selections = cloneDeep(state.selections);
      let current = selections[action.payload.reportType];
      if (current && partialMatches(current)) {
        selections[action.payload.reportType].imageUri = null;
        selections[action.payload.reportType].zoom = 1.0;
        selections[action.payload.reportType].x = 0;
        selections[action.payload.reportType].y = 0;
      }

      return {
        ...state,
        custom,
        selections,
      };
    case SELECT:
      return {
        ...state,
        selections: {
            ...state.selections,
            ...action.payload,
        },
      };
    case FRANCHISE:
      return {
          ...state,
          ...action.payload,
      };
    default:
      return state;
  }
};

export default CoverPageImagesDuck;

export function updateCoverPageImages() {
  return async (dispatch) => {
    const maxRetryAttempts = 3;
    let retryAttempts = 0;
    let returnObj;
    while (!returnObj && retryAttempts < maxRetryAttempts) {
      try {
        const response = await axios.get('/api/coverPageImages');
        if (response?.data) {
          returnObj = {
            type: FRANCHISE,
            payload: response.data
          };
        }
      }
      catch (e) {
        retryAttempts++;
        await sleep(1000);
      }
    }
    if (returnObj) {
      dispatch(returnObj);
    }
  };
}

export function mkImageSelection({imageUri, invalidImage = false, reportType, type, zoom, x, y}) {
  let payload = {};
  payload[reportType] = {
    imageUri,
    invalidImage,
    type,
    zoom: zoom || 1.0,
    x: x || 0,
    y: y || 0,
  };
  return {
    type: SELECT,
    payload,
  };
}

export function addCustomCoverImage({imageUri, type}) {
  return {
    type: ADD_IMAGE,
    payload: {
      imageUri,
      type,
    }
  };
}

export function removeCustomCoverImage({imageUri, reportType, type}) {
  return {
    type: REMOVE_IMAGE,
    payload: {
      custom: {
        imageUri,
        type,
      },
      reportType,
    }
  };
}
